export const GET_FILES_INFO = 'GET_FILES_INFO';
export const GET_FILES_INFO_SUCCESS = 'GET_FILES_INFO_SUCCESS';
export const GET_FILES_INFO_FAIL = 'GET_FILES_INFO_FAIL';

export const GET_CONTACTS_BY_TYPE = 'GET_CONTACTS_BY_TYPE';
export const GET_CONTACTS_BY_TYPE_SUCCESS = 'GET_CONTACTS_BY_TYPE_SUCCESS';
export const GET_CONTACTS_BY_TYPE_FAIL = 'GET_CONTACTS_BY_TYPE_FAIL';

export const GET_FILES_CONTROL_CONFIGURATION = 'GET_FILES_CONTROL_CONFIGURATION';
export const GET_FILES_CONTROL_CONFIGURATION_SUCCESS = 'GET_FILES_CONTROL_CONFIGURATION_SUCCESS';
export const GET_FILES_CONTROL_CONFIGURATION_FAIL = 'GET_FILES_CONTROL_CONFIGURATION_FAIL';

export const VERIFY_FOLDER_STRUCTURE = 'VERIFY_FOLDER_STRUCTURE';
export const VERIFY_FOLDER_STRUCTURE_SUCCESS = 'VERIFY_FOLDER_STRUCTURE_SUCCESS';
export const VERIFY_FOLDER_STRUCTURE_FAIL = 'VERIFY_FOLDER_STRUCTURE_FAIL';

export const SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_START = 'SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_START';
export const SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_SUCCESS = 'SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_SUCCESS';
export const SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_FAIL = 'SEND_FILES_GET_SEND_POLICY_PACKAGE_INFO_FAIL';

export const SEND_CERTIFICATE_FILES_START = 'SEND_CERTIFICATE_FILES_START';
export const SEND_CERTIFICATE_FILES_SUCCESS = 'SEND_CERTIFICATE_FILES_SUCCESS';
export const SEND_CERTIFICATE_FILES_FAIL = 'SEND_CERTIFICATE_FILES_FAIL';
